import { expiredUser } from '_services/login-service'
import { onError } from "@apollo/client/link/error"

const errorLink = onError(({ graphQLErrors }) => {
  const expired = graphQLErrors && !!graphQLErrors.find(e => e.message.indexOf("Expired token") > -1)
  if (expired) expiredUser()
})

export default errorLink
